import L from "leaflet";

/** Real tile readiness controls the reveal; no fabricated progress percentage. */
export class BootScreen {
    constructor(map) {
        this.map = map;
        this.node = document.getElementById("sm-boot");
        if (this.node && location.hash === "#map") {
            this.node.remove();
            this.node = null;
        }
        this.active = !!this.node;
        if (!this.active) return;
        this.layers = new Set();
        this.started = performance.now();
        this.reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.minimum = this.reduced ? 0 : 2100;
        this.node.querySelector(".sm-boot-skip").onclick = (event) => {
            event.preventDefault();
            this.finish();
        };
        this.keyListener = (event) => {
            if (!this.active) return;
            if (event.key === "Escape") {
                event.preventDefault();
                this.finish();
            }
            if (event.key === "Tab") {
                event.preventDefault();
                this.node.querySelector(".sm-boot-skip").focus();
            }
        };
        document.addEventListener("keydown", this.keyListener);
        this.node.querySelector(".sm-boot-skip").focus({ preventScroll: true });
        document.getElementById("map").inert = true;
        this.ready = () => {
            if (!this.active || this.revealTimer) return;
            this.node.querySelector(".sm-boot-status").textContent = "World ready";
            this.node.classList.add("sm-boot-ready");
            this.revealTimer = setTimeout(
                () => this.finish(),
                Math.max(0, this.minimum - (performance.now() - this.started)),
            );
        };
        this.observe = (layer) => {
            if (!(layer instanceof L.GridLayer)) return;
            this.layers.add(layer);
            layer.once("tileload", this.ready);
            this.node.querySelector(".sm-boot-status").textContent = "Loading map";
        };
        this.layerListener = (event) => this.observe(event.layer);
        map.on("layeradd", this.layerListener);
        map.eachLayer(this.observe);
        this.timeout = setTimeout(() => this.finish(), 8000);
    }
    finish() {
        if (!this.active) return;
        this.active = false;
        clearTimeout(this.timeout);
        clearTimeout(this.revealTimer);
        document.removeEventListener("keydown", this.keyListener);
        this.map.off("layeradd", this.layerListener);
        this.layers.forEach((layer) => layer.off("tileload", this.ready));
        document.getElementById("map").inert = false;
        const shell = document.querySelector(".sm-app");
        if (shell) shell.inert = false;
        if (this.node.contains(document.activeElement)) document.activeElement.blur();
        this.node.classList.add("sm-boot-exit");
        this.node.setAttribute("aria-hidden", "true");
        this.node.inert = true;
        this.removeTimer = setTimeout(() => this.node.remove(), this.reduced ? 0 : 700);
    }
    dispose() {
        this.finish();
        clearTimeout(this.removeTimer);
        this.node?.remove();
    }
}
